'use strict';
import request from '@/utils/request';
class ReferredService{
    static list(query){
        return request({
            url:'/users/referred',
            method:'get',
            timeout:60000,
            params:query
        })
    }
    static listCoupons(query){
        return request({
            url:'/users/referred-coupons',
            method:'get',
            timeout:60000,
            params:query
        })
    }
    
    static create(data){
        return request({
            url:'/users/referred',
            method:'post',
            data
        });
    }
    static update(data){
        return request({
            url:'/users/referred',
            method:'put',
            data
        });
    }
    static remove(data){
        return request({
            url:'/users/referred',
            method:'delete',
            data
        });
    }
}

export default ReferredService;
